<template>
  <div class="account-appeal-index">
    <h3>账号申诉</h3>
    <p>请输入申诉的身份证号码</p>
    <van-form class="second-phone-form" @submit="onSubmit">
      <van-field
        @input="userIdcardCheck"
        type="text"
        v-model="userIdcard"
        label="身份证号码"
        label-width="2.5rem"
        placeholder="请输入申诉的身份证号码"
        :rules="[{ required: true, message: '请输入申诉的身份证号码' }]"
        class="userType from-field-phone"
        maxlength="18"
        clearable
      />
      <van-field
        readonly
        clickable
        label-width="2.5rem"
        name="userType"
        :value="userType"
        label="用户类型"
        placeholder="点击选择用户类型类型"
        @click="showPicker = true"
        class="userType from-field-phone"
      />
      <!--<van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
        </van-popup>-->
      <div class="from-button">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          :disabled="!userIdcard || !userType"
          >下一步</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { encryptByAES, encryptKey } from "../../api/encryption";
export default {
  data() {
    return {
      userIdcard: "",
      userType: "自然人",
      columns: ["自然人"],
      showPicker: false,
    };
  },
  computed: {
    ...mapGetters({ getidcard: "idcard" }),
  },
  created() {},
  methods: {
    ...mapActions({ setIdcard: "user/setIdcard" }),
    userIdcardCheck() {
      //验证输入框内不能输入特殊字符,汉字,输入就立刻清除
      this.userIdcard = this.userIdcard.replace(/[^0-9Xx]/g, "");
    },
    onSubmit() {
      let idCardReg =
        /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      if (this.userIdcard.length != 18 || !idCardReg.test(this.userIdcard)) {
        return this.$toast("身份证号格式不正确!");
      }
      this.setIdcard(this.userIdcard); //存身份证号
      // this.JSBridge.showLoading("数据加载中..");
      // this.$axios({
      //     url: "/vi/findPsnInfoByIdCardStepOne",
      //     method: "post",
      //     data: {
      //         loginName: this.userIdcard,
      //         zwfwType: this.userType=="自然人" ? "1":"2"
      //     }
      // this.JSBridge.requestRpc({
      //     url: "com.abchina.xyl.findPsnInfoByIdCardStepOne",
      //     params: {
      //         loginName: this.userIdcard,
      //         zwfwType: "1"
      //     }
      this.request({
        url: "/sga/user/findPsnInfoByIdCardStepOne",
        type: "post",
        params: {
          loginName: encryptByAES(this.userIdcard, encryptKey),
          zwfwType: "1",
        },
      })
        .then((res) => {
          // console.log(res);
          this.JSBridge.hideLoading();
          if (res.respCode == "00000000") {
            this.$router.push({ path: `/accountAppeal/thirdIdcard` });
          } else {
            this.$toast(res.respMsg);
          }
        })
        .catch((error) => {
          this.JSBridge.hideLoading();
          console.log(error);
        });
    },
    onConfirm(value) {
      this.userType = value;
      this.showPicker = false;
    },
  },
};
</script>

<style scoped lang="less">
#app .child-view {
  background-color: #ffffff;
}
.account-appeal-index {
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
}
.account-appeal-index h3 {
  font-size: 0.8rem;
  color: #287bac;
  margin-bottom: 5px;
  font-weight: 400;
}
.account-appeal-index p {
  font-size: 0.4rem;
  color: #999999;
  letter-spacing: 1.5px;
  margin-top: 10px;
}
.second-phone-form {
  margin-top: 25%;
}
.from-field-phone {
  font-size: 0.4rem;
  padding: 15px 10px;
  line-height: 25px;
  box-sizing: border-box;
}
.userType {
  font-size: 0.4rem;
  padding-left: 0;
}
.van-cell:not(:last-child)::after {
  border: none;
}
.van-cell {
  border-bottom: 0.02667rem solid #ebedf0;
}
.from-button {
  width: 100%;
  border-radius: 5px;
  button {
    border-radius: 3px;
    margin-top: 20px;
    height: 50px;
  }
}
</style>
